/**************************************************************************************************/
/*   File: /src/app/shared/models/protocolled.file.ts                                             */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 1st 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Mon Apr 01 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LocalDocument } from './local.document';

/**
 * The protocolled file
 */
export class ProtocolledFile {
    /**
     * The document
     */
    document: LocalDocument;
    /**
     * The protocol id
     */
    protocolId: string;
    /**
     * The protocol date
     */
    protocolledDate: Date;
}